import _ from "lodash";

import React, { useState } from "react";

import FullScreenLoader from "../FullScreenLoader";
import { useMount } from "Hooks";

import { useDispatch } from "Hooks/useDispatch";
import {
  getPublicToken,
  setPublicToken,
  setToastMsg,
} from "Login/modules/LoginModule";

import { goToPageNotFound } from "modules/NavigationModule";

import classes from "./WithPublicToken.scss";

const withPublicToken = WrappedComponent => {
  const PublicToken = props => {
    const [isPublicTokenStored, setIsPublicTokenStored] = useState(false);

    const dispatch = useDispatch();

    const isLoading = _.get(props, "isLoading");
    const publicToken = _.get(props, "publicToken");

    useMount(() => {
      const fetchToken = async () => {
        if (_.isEmpty(publicToken)) {
          const token = await getPublicToken({
            type: "PUBLIC",
          });

          if (!_.isEmpty(token)) {
            dispatch(setPublicToken(token));
          } else {
            dispatch(setToastMsg("toastMsgs:something_went_wrong"));
            dispatch(goToPageNotFound());
          }
        }
        setIsPublicTokenStored(true);
      };

      fetchToken();
    });

    const showFullScreenLoader =
      _.isEmpty(publicToken) && !isPublicTokenStored && !isLoading;

    if (showFullScreenLoader) {
      return <FullScreenLoader overlayContainer={classes.fullScreenLoader} />;
    }

    return <WrappedComponent {...props} />;
  };
  return PublicToken;
};

export default withPublicToken;
